import HeroImage from 'content/components/HeroImage'
import * as React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { TourSearchContainerPaneRoot } from './TourSearchContainerPane'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'

export type TourHeroImageGravityType = 'auto' | 'center' | 'east' | 'north' | 'northeast' | 'northwest' | 'south' | 'southeast' | 'southwest' | 'west'

const HeroContainer = styled(HeroImage)`
  position: relative;
  padding: ${rem(48)} 0;
  min-height: unset;

  ${mediaQueryUp.tablet} {
    justify-content: center;
    min-height: ${rem(289)};
    padding: ${rem(40)} 0;
  }
`

const HeroContent = styled(LayoutContainer)`
  position: relative;

  ${mediaQueryUp.tablet} {
    transform: translateY(${rem(-16)});

    > .center {
      text-align: center;
    }

    > .hero-heading + ${TourSearchContainerPaneRoot} {
      margin-top: ${rem(24)};
      text-align: center;
    }
  }
`

const HeroDimmedOverlay = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  inset-inline: 0;
  background-color: rgba(0, 0, 0, 0.2);
  pointer-events: none;
`

interface Props {
  children?: React.ReactNode
  heroImageId: string
  title: React.ReactNode
  subtitle: string
  className?: string
  /**
   * @default auto
   */
  gravity?: TourHeroImageGravityType
  aspectRatio?: string
  tabletAspectRatio?: string
}

const TourSearchHeroContainer = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { aspectRatio, tabletAspectRatio, children, heroImageId, title, className, gravity, subtitle } = props

  return <HeroContainer
    fit="center"
    gravity={gravity ?? 'auto'}
    id={heroImageId}
    mobileAspectRatio={aspectRatio ?? '8:9'}
    tabletAspectRatio={tabletAspectRatio ?? '10:3'}
    className={className}
  >
    <HeroDimmedOverlay aria-hidden="true" role="presentation" />
    <HeroContent ref={ref}>
      <Heading colour="dark-contrast" variant="heading2" className="hero-heading center">
        {title}
      </Heading>
      {subtitle && <BodyText variant="large" colour="dark-contrast" className="center">{subtitle}</BodyText>}
    </HeroContent>
    {children}
  </HeroContainer>
})

TourSearchHeroContainer.displayName = 'TourSearchHeroContainer'

export default TourSearchHeroContainer
